/** @module csi/image/refreshWithLabel **/
define([
	"csi/def/ActionFactory",
	"csi/view/Refresh"
], function(ActionFactory,Refresh) {
	return ActionFactory.declare("refreshWithLabel", Refresh, {
		m_id: "ViewRefreshWithLabel",
		classController: "csi/view/RefreshController",
		classToolbarPluginParams: {
			showLabelWithIcon: true
		}
	});
});